export default {
  footer: {
    itemsPerPageOptions: [5, 10, 25, 100],
  },
};
